import { IconProps } from "./types";

export const CheckIcon: React.FC<IconProps> = ({ uuid, fillColor }) => {
  return (
    <svg
      id={`check-icon-${uuid}`}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.0127 5.76122L7.12269 11.6512H7.14269C6.95269 11.8312 6.7027 11.9412 6.4327 11.9412C6.1627 11.9412 5.9127 11.8412 5.7227 11.6512L2.9927 8.92122C2.6027 8.53122 2.6027 7.90122 2.9927 7.51122C3.3827 7.12122 4.0127 7.12122 4.4027 7.51122L6.4227 9.53122L11.6027 4.35122C11.9927 3.96122 12.6227 3.96122 13.0127 4.35122C13.4027 4.74122 13.4027 5.37122 13.0127 5.76122Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
